import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { global } from '@angular/core/src/util';
import { GlobalProvider } from '../global/global';
/*
  Generated class for the PaisProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ProgramaProvider {

  private api: string;

  //private api;
  // , public  rurasdirective : RutasDirective
  constructor(public http: Http, public global: GlobalProvider) {
    this.api = this.global.api;
    console.log('Hello PaisProvider Provider');
    //this.api = rurasdirective.ruta;
  }

  // Devuelve todos el programa de un congreso
  public all(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };


    return this.http.post(this.api + "programa/lista_sin.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public evento(clavecongreso,clave): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "clave": clave,
      "clavecongreso": clavecongreso
    };


    return this.http.post(this.api + "programa/evento.php", parametros, options).map(
      (response) => {

        var respuesta = response.json();

        return respuesta[0];

      }
    ).catch(this.handleError);
  }
  public allnotitulo(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };


    return this.http.post(this.api + "programa/listanotitulo.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }


  // Devuelve todos el programa de un congreso
  public preguntaslist(clavepregunta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "tabla": "preguntasponentes",
      "campofiltro": "claveprograma",
      "valorfiltro": clavepregunta,
      "campoorden": "fecha desc"
    };
    console.log(parametros);

    return this.http.post(this.api + "apigen/list.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }

  // Devuelve todos los ponentes de un programa
  public preguntaponente(claveprograma, moderado, texto): Observable<any> {
    var estado = 0;
    if (moderado == 0) {
      estado = 1;
    } else {
      estado = 0;
    }
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveprograma": claveprograma,
      "usuario": this.global.usuario,
      "texto": texto,
      "estado": estado,
      "token": this.global.token
    };


    return this.http.post(this.api + "congresos/preguntasponentes.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public preguntaponenteestado(pregunta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "tabla": "preguntasponentes",
      "clave": pregunta.clave,
      "parametros": pregunta
    };


    return this.http.post(this.api + "apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }
  public programa_favoritos(claveprograma, operacion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveprograma": claveprograma,
      "token": this.global.token
    };


    if (operacion == 1) {
      return this.http.post(this.api + "programa/insert.php", parametros, options).map(
        (response) => {

          return response.json();

        }
      ).catch(this.handleError);
    } else {
      return this.http.post(this.api + "programa/delete.php", parametros, options).map(
        (response) => {

          return response.json();

        }
      ).catch(this.handleError);
    }

  }



  // Devuelve todos los programas de un ponente
  public programaponentes(claveponente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "claveponente": claveponente
    };


    return this.http.post(this.api + "congresos/programaponentes.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }


  // Devuelve todos los ponentes de un programa
  public ponentesprograma(claveprograma): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "claveprograma": claveprograma
    };


    return this.http.post(this.api + "congresos/ponentesprograma.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }

  public preguntasprograma(clavepregunta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavepregunta": clavepregunta
    };

    return this.http.post(this.api + "congresos/preguntasprograma.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }
  public programapreguntas(claveprograma): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "claveprograma": claveprograma
    };

    return this.http.post(this.api + "programa/preguntasprograma.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }
  public documentosprograma(clavedocumento): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavedocumento": clavedocumento
    };

    return this.http.post(this.api + "congresos/documentosprograma.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }

  // Inserta en el programa.  
  public insert(congresoactivo, evento): Observable<any> {


    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;
    evento.guid_enlace = this.newGuid();
    let parametros = {
      "token": this.global.token,
      "tabla": "programa",
      "parametros": evento,
      "clavecongreso": congresoactivo.clave
    };
    console.log(parametros);

    return this.http.post(this.api + "apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  // Inserta en el programa.  
  public update(congresoactivo, evento): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "tabla": "programa",
      "clave": evento.clave,
      "parametros": evento,
      "clavecongreso": congresoactivo.clave
    };

    console.log(parametros);
    return this.http.post(this.api + "apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }

  // Elimina un congreso
  public delete(nnprograma): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "programa",
      "clave": nnprograma,
    };


    return this.http.post(this.api + "apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }



  // Inserta en el programa.  
  public guardaponentes(claveprograma, ponentes): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "claveprograma": claveprograma,
      "ponentes": ponentes
    };


    return this.http.post(this.api + "congresos/ponentescongreso.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  public guardapreguntas(claveprograma, preguntas): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "claveprograma": claveprograma,
      "preguntas": preguntas
    };

    console.log(parametros);
    console.log(this.api + "programa/guardapreguntas.php");
    return this.http.post(this.api + "programa/guardapreguntas.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta en el programa.  
  public guardaprogramapregunta(clavepregunta, programas): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "clavepregunta": clavepregunta,
      "programas": programas
    };


    return this.http.post(this.api + "congresos/guardapreguntasprograma.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }
  // Inserta en el programa.  
  public guardaprogramadocumento(clavedocumento, programas): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros = {
      "token": this.global.token,
      "clavedocumento": clavedocumento,
      "programas": programas
    };


    return this.http.post(this.api + "congresos/guardadocumentosprograma.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Valora una ponencia
  public valorarprograma(claveprograma, valoracion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "claveprograma": claveprograma,
      "dispositivo": this.global.guid,
      "valoracion": valoracion
    };

    return this.http.post(this.api + "congresos/valorarprograma.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Devuelve todos los programas de un ponente
  public duplica(clave): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clave": clave
    };


    return this.http.post(this.api + "programa/duplica.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  // Rutina de errores
  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/providers/programa/programa.ts